// import "../../CustomStyles/customStyle.css";
// import "../ShareApp/sharethisapp.css";
// import Minagaramlogo from "../../assets/Agarathi_logo.png";
// import PlayStorelogo from "../../assets/SharethisApp/PlayStore.svg";
// import AppStorelogo from "../../assets/SharethisApp/AppStore.svg";
// import STA_MobileScreen from "../../assets/Frame 870.png";
// import { Button, Menu, Dropdown, message } from "antd";
// import BackgroundImage from "../../assets/background_Image.png";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
 
// import {
//   STR_Agarathi,
//   STR_Tam_agarathi,
//   STR_Tam_text1_STA,
//   STR_Tam_text2_STA,
//   STR_Tam_text4_STA,
//   STR_text1_STA,
//   STR_text2_STA,
//   STR_text3_STA,
//   STR_text4_STA,
//   STR_Copy_Failure_STA,
//   STR_Copy_STA,
//   STR_Copy_Success_STA,
//   STR_Share,
//   STR_Tam_Copy_Failure_STA,
//   STR_Tam_Copy_STA,
//   STR_Tam_Copy_Success_STA,
//   STR_Tam_Share,
// } from "../../Config.js/Strings";
// import { ShareAltOutlined, LinkOutlined } from "@ant-design/icons";
// import { WhatsappShareButton, WhatsappIcon } from "react-share";
 
// import { connect } from "react-redux";
// import Footer from "../../Components/Footer/Footer";
// const SharethisApp = ({ isTamil }) => {
//   const testimonials = [
//     {
//       text: "Clean UI and quick search functionality make this app my go-to dictionary. Love the daily word feature!",
//       user: "Ethan",
//     },
//     {
//       text: "I use Min Agaram every day. It’s meaningful, easy to use, and a true gift for Tamil learners.",
//       user: "Olivia",
//     },
//     {
//       text: "Thanks to Min Agaram, I now enjoy learning Tamil every day.",
//       user: "Liam",
//     },
//     {
//       text: "Such a helpful app for students! I use it for all my assignments and exam prep.",
//       user: "Sophia",
//     },
//     {
//       text: "This app is awesome! Every time I use it, I find new words. It’s fun to explore and learn with it!",
//       user: "James",
//     },
//     {
//       text: "Love the daily word push notifications! Helps me expand my vocabulary every day.",
//       user: "Logan ",
//     },
//   ];
 
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//         },
//       },
//     ],
//   };
 
//   let agarathi_token = localStorage.getItem("agarathi_token");
 
//   const shareUrl = "http://13.126.65.58/Min-landing";
 
//   const handleCopy = async () => {
//     try {
//       if (navigator.clipboard && window.isSecureContext) {
//         await navigator.clipboard.writeText(shareUrl);
//         message.success(
//           isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
//         );
//       } else {
//         // Fallback for non-secure contexts or browsers without clipboard API
//         const textArea = document.createElement("textarea");
//         textArea.value = shareUrl;
//         document.body.appendChild(textArea);
//         textArea.focus();
//         textArea.select();
//         try {
//           document.execCommand("copy");
//           message.success(
//             isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
//           );
//         } catch (err) {
//           message.error(
//             isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA
//           );
//         } finally {
//           document.body.removeChild(textArea);
//         }
//       }
//     } catch (error) {
//       message.error(isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA);
//     }
//   };
 
//   const menu = (
//     <Menu>
//       <Menu.Item key="1">
//         <WhatsappShareButton url={shareUrl}>
//           <WhatsappIcon size={32} round />
//         </WhatsappShareButton>
//       </Menu.Item>
//       {/* <Menu.Item key="2">
//         <FacebookShareButton url={shareUrl}>
//           <FacebookIcon size={32} round />
//         </FacebookShareButton>
//       </Menu.Item>
//       <Menu.Item key="3">
//         <TwitterShareButton url={shareUrl}>
//           <TwitterIcon size={32} round />
//         </TwitterShareButton>
//       </Menu.Item> */}
//       <Menu.Item key="2" onClick={handleCopy}>
//         <Button className="copylink" icon={<LinkOutlined />} type="link">
//           {isTamil ? STR_Tam_Copy_STA : STR_Copy_STA}
//         </Button>
//       </Menu.Item>
//     </Menu>
//   );
 
//   function Card({ icon, title }) {
//     return (
//       <div className="share_page_card">
//         <img src={icon} alt={title} className="share_page_icon" />
//         <h3 className="share_page_title">{title}</h3>
//       </div>
//     );
//   }
 
//   return (
//     <div>
//       <div className="wholecontainer_STA">
//         <div className="container_STA">
//           <div className="minagaramlogoContainer_STA">
//             <img src={Minagaramlogo} className="minagaramlogo_STA" />
//           </div>
//           <h1 className="header_STA">
//             {isTamil ? STR_Tam_agarathi : STR_Agarathi}
//           </h1>
//           <p className={`${isTamil ? "text_STA_1_T" : "text_STA_1"}`}>
//             {isTamil ? STR_Tam_text1_STA : STR_text1_STA}
//           </p>
//           <p className={`${isTamil ? "text_STA_T" : "text_STA"}`}>
//             {isTamil ? STR_Tam_text2_STA : STR_text2_STA}
//           </p>
 
//           <Dropdown
//             overlay={menu}
//             trigger={["click"]}
//             className="shareIcon_STA"
//           >
//             <Button type="black" icon={<ShareAltOutlined />}>
//               {isTamil ? STR_Tam_Share : STR_Share}
//             </Button>
//           </Dropdown>
 
//           <p className={`${isTamil ? "textBold_STA_T" : "textBold_STA"}`}>
//             {isTamil ? STR_Tam_text4_STA : STR_text4_STA}
//           </p>
//           <div className="shareButtonContainer_STA">
//             <div className="shareButton_STA">
//               <a
//                 href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src={AppStorelogo}
//                   alt="App Store"
//                   className="AppStorelogo"
//                 />
//               </a>
//               <a
//                 href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src={PlayStorelogo}
//                   alt="Google Play"
//                   className="PlayStorelogo"
//                 />
//               </a>
//             </div>
//           </div>
//         </div>
//         <img
//           src={STA_MobileScreen}
//           alt="MobileScreen"
//           className="mobileScreen_STA"
//         />
//       </div>
//       <div className="home_screen_page_new">
//         <h1 className="share_page_feature">Home Screen</h1>
//         <div className="share_page_background_image">
//           <p className="share_page_contect_icons share_paragraphy  ">
//             Notifications in Min Agaram keep users updated on new words, tips,
//             and app enhancements.
//           </p>
//           <div className="share_paragraphy_01">
//             <p className="share_page_contect_icons  share_page_navication share_paragraphy_010 new_para ">
//               Allows users to access essential features quickly for an efficient
//               and user-friendly experience.
//             </p>
//             <p className="share_page_contect_icons share_paragraphy_010 new_one1">
//               {/* The Word of the Day in Min Agaram
//             helps users leam a new Tamil word
//             daily and expand their vocabulary. */}
//               The Search Bar in Min Agaram enables quick and accurate word
//               search with smart suggestions.
//             </p>
//           </div>
//           <div className="share_paragraphy_02">
//             <p className="share_page_contect_icons share_page_navication01 share_paragraphy_010 word_of_the_day_01">
//               The Word of the Day in Min Agaram helps users leam a new Tamil
//               word daily and expand their vocabulary.
//             </p>
//             <p className="share_page_contect_icons share_paragraphy_010 new_one1 share_page_saved_01">
//               The Saved Words feature in Min Agaram lets users bookmark and
//               revisit important words easily.
//             </p>
//           </div>
//           {/* <img src={icon10} style={{ width: "550px", height: "500px", marginLeft: "420px" }}  */}
 
//           {/* /> */}
//         </div>
//       </div>
//       <div>
//         <h1>
//           <h1 className="share_page_feature  share_page_feature_011">
//             Feature
//           </h1>
//         </h1>
//         <div className="share_page_01">
//           <div className="share_grid_02">
//             <Card icon={icon1} title="Word of the day" />
//             <Card icon={icon2} title="Image" />
//             <Card icon={icon3} title="Audio" />
//             <Card icon={icon4} title="Select levels" />
//             <Card icon={icon5} title="Recently Viewed" />
//             <Card icon={icon6} title="Saved Words" />
//             <Card icon={icon7} title="Idioms" />
//             <Card icon={icon8} title="Metaphors" />
//             <Card icon={icon9} title="Phrasemes" />
//           </div>
//         </div>
//       </div>
//       <div>
//         <h1 className="share_page_feature">Feedback</h1>
//         <div className="slider_last_01 last_slider_new_one">
//           <Slider {...settings}>
//             {testimonials.map((item, i) => (
//               <div key={i} style={{ padding: "0 1px" }}>
//                 <div className="slider_01">
//                   <div>
//                     {/* If you want to bring back the icon, consider using flex/grid */}
//                     <img src={icon11} className="slider_image" />
 
//                     <div style={{ position: "relative", bottom: "30px" }}>
//                       <p
//                         style={{
//                           color: "rgb(0, 191, 255)",
//                           fontWeight: "bold",
//                           marginBottom: "10px",
//                           fontSize: "20px",
//                         }}
//                       >
//                         {item.user}
//                       </p>
//                       <p style={{ color: "black" }}>{item.text}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </Slider>
//         </div>
//       </div>
//       <div className="mt-10 new_home_footer">
//         <Footer />
//       </div>
//     </div>
//   );
// };
 
// // Map Redux state to component props
// const mapStateToProps = (state) => ({
//   isTamil: state.LanguageReducer.isTamil,
// });
 
// export default connect(mapStateToProps)(SharethisApp);
 
import "../ShareApp/sharethisapp.css";
import { Button, Menu, Dropdown, message, Layout } from "antd";
import { Card, Col, Row } from "antd";
import backgroundimage from "../../assets/SharethisApp/backgroundimage.png";
import landingmobile from "../../assets/SharethisApp/landingmobile.png";
import share_icon from "../../assets/SharethisApp/share_icon.png";
import mobilescreen2 from "../../assets/SharethisApp/mobilescreen2.png";
import PlayStorelogo from "../../assets/SharethisApp/PlayStore.svg";
import AppStorelogo from "../../assets/SharethisApp/AppStore.svg";
import imgf_1 from "../../assets/SharethisApp/imgf_1.png";
import imgf_2 from "../../assets/SharethisApp/imgf_2.png";
import imgf_3 from "../../assets/SharethisApp/imgf_3.png";
import user_icon from "../../assets/SharethisApp/user_icon.png";
import Download from "../../assets/SharethisApp/Download.png";
import MobileLayout from "../../assets/SharethisApp/Mobile-Layout.png";
import {
  STR_Tam_text1_STA,
  STR_Tam_text2_STA,
  STR_Tam_text4_STA,
  STR_Tam_text5_STA,
  STR_Tam_text6_STA,
  STR_Tam_text7_STA,
  STR_Tam_text8_STA,
  STR_Tam_text9_STA,
  STR_Tam_text10_STA,
  STR_Tam_text11_STA,
  STR_Tam_text12_STA,
  STR_Tam_text13_STA,
  STR_Tam_text14_STA,
  STR_Tam_text15_STA,
  STR_Tam_text16_STA,
  STR_Tam_text17_STA,
  STR_Tam_text18_STA,
  STR_Tam_text19_STA,
  STR_Tam_text20_STA,
  STR_text1_STA,
  STR_text2_STA,
  STR_text4_STA,
  STR_text5_STA,
  STR_text6_STA,
  STR_text7_STA,
  STR_text8_STA,
  STR_text9_STA,
  STR_text10_STA,
  STR_text11_STA,
  STR_text12_STA,
  STR_text13_STA,
  STR_text14_STA,
  STR_text15_STA,
  STR_text16_STA,
  STR_text17_STA,
  STR_text18_STA,
  STR_text19_STA,
  STR_text20_STA,
  STR_Copy_Failure_STA,
  STR_Copy_STA,
  STR_Copy_Success_STA,
  STR_Share,
  STR_Tam_Copy_Failure_STA,
  STR_Tam_Copy_STA,
  STR_Tam_Copy_Success_STA,
  STR_Tam_Share,
} from "../../Config.js/Strings";
import { LinkOutlined } from "@ant-design/icons";
import { WhatsappShareButton, WhatsappIcon } from "react-share";
import { connect } from "react-redux";
import Footer from "../../Components/Footer/Footer";
const SharethisApp = ({ isTamil }) => {
  const ShareIntroSection = () => {
    let agarathi_token = localStorage.getItem("agarathi_token");
    const shareUrl = "https://minagaram.com/Min-landing";
 
    const handleCopy = async () => {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(shareUrl);
          message.success(
            isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
          );
        } else {
          // Fallback for non-secure contexts or browsers without clipboard API
          const textArea = document.createElement("textarea");
          textArea.value = shareUrl;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          try {
            document.execCommand("copy");
            message.success(
              isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
            );
          } catch (err) {
            message.error(
              isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA
            );
          } finally {
            document.body.removeChild(textArea);
          }
        }
      } catch (error) {
        message.error(
          isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA
        );
      }
    };
 
    const menu = (
      <Menu>
        <Menu.Item key="1">
          <WhatsappShareButton url={shareUrl}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </Menu.Item>
        <Menu.Item key="2" onClick={handleCopy}>
          <Button className="copylink" icon={<LinkOutlined />} type="link">
            {isTamil ? STR_Tam_Copy_STA : STR_Copy_STA}
          </Button>
        </Menu.Item>
      </Menu>
    );
    return (
      <div>
        <div className="sharemain_screen">
          <div className="backgrdimg_1">
            <img src={backgroundimage} className="wave_img"></img>
          </div>
          <div className="text_container">
            <p className={`${isTamil ? "text_STA_1_T" : "text_STA_1"}`}>
              {isTamil ? STR_Tam_text1_STA : STR_text1_STA}
            </p>
            <p className={`${isTamil ? "text_STA_T" : "text_STA"}`}>
              {isTamil ? STR_Tam_text2_STA : STR_text2_STA}
            </p>
            <Dropdown overlay={menu} trigger={["click"]} className="shareIcon">
              <Button
                type="white"
                icon={
                  <img src={share_icon} alt="share" className="share-img" />
                }
              >
                {isTamil ? STR_Tam_Share : STR_Share}
              </Button>
            </Dropdown>
          </div>
          <div className="backgrd_phone">
            <img src={landingmobile} className="phone_img"></img>
          </div>
        </div>
      </div>
    );
  };
  const DownloadSection = () => {
    return (
      <div className="downloadscreen">
        <div className="downloadphone">
          <img src={mobilescreen2} className="phone_two"></img>
        </div>
        <div className="download_content">
          <p className={`${isTamil ? "downloadbold_T_2" : "downloadbold_2"}`}>
            {isTamil ? STR_Tam_text4_STA : STR_text4_STA}
          </p>
          <p className={`${isTamil ? "downloadtext_T_2" : "downloadtext_2"}`}>
            {isTamil ? STR_Tam_text5_STA : STR_text5_STA}
          </p>
          <div className="shareButton_two">
            <a
              href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={AppStorelogo}
                alt="App Store"
                className="AppStorelogo"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={PlayStorelogo}
                alt="Google Play"
                className="PlayStorelogo"
              />
            </a>
          </div>
        </div>
      </div>
    );
  };
  const FeaturesSection = () => {
    return (
      <div className="features-section">
        <div className="features_heading">
          <p className={`${isTamil ? "feature_head_t" : "feature_head"}`}>
            {isTamil ? STR_Tam_text6_STA : STR_text6_STA}
          </p>
          <p className={`${isTamil ? "feature_subhead_t" : "feature_subhead"}`}>
            {isTamil ? STR_Tam_text7_STA : STR_text7_STA}
          </p>
        </div>
        <div className="features_cards">
          <div className="featurecard_1">
            <img src={imgf_1} className="imgfeature_1"></img>
            <p className={`${isTamil ? "featurebold_T_1" : "featurebold_1"}`}>
              {isTamil ? STR_Tam_text8_STA : STR_text8_STA}
            </p>
            <p
              className={`${
                isTamil ? "featurecontent_T_1" : "featurecontent_1"
              }`}
            >
              {isTamil ? STR_Tam_text9_STA : STR_text9_STA}
            </p>
          </div>
          <div className="featurecard_2">
            <img src={imgf_2} className="imgfeature_2"></img>
            <p className={`${isTamil ? "featurebold_T_2" : "featurebold_2"}`}>
              {isTamil ? STR_Tam_text10_STA : STR_text10_STA}
            </p>
            <p
              className={`${
                isTamil ? "featurecontent_T_2" : "featurecontent_2"
              }`}
            >
              {isTamil ? STR_Tam_text11_STA : STR_text11_STA}
            </p>
          </div>
          <div className="featurecard_3">
            <img src={imgf_3} className="imgfeature_3"></img>
            <p className={`${isTamil ? "featurebold_T_3" : "featurebold_3"}`}>
              {isTamil ? STR_Tam_text12_STA : STR_text12_STA}
            </p>
            <p
              className={`${
                isTamil ? "featurecontent_T_3" : "featurecontent_3"
              }`}
            >
              {isTamil ? STR_Tam_text13_STA : STR_text13_STA}
            </p>
          </div>
        </div>
      </div>
    );
  };
  const CardsSection = () => {
    return (
      <div className="cards-section">
        <div className="card_heading">
          <p className={`${isTamil ? "card_head_t" : "card_head"}`}>
            {isTamil ? STR_Tam_text14_STA : STR_text14_STA}
          </p>
        </div>
        <Row gutter={15} justify="center" className="three_cards">
          <Col className="cards_type" span={8}>
            <div className="card-circle">
              <div className="card-wrapper">
                <div className="icon-circle">
                  <img src={user_icon} className="cards_icon"></img>
                </div>
              </div>
            </div>
            <Card title="" bordered={false} className="customcard-overlap">
              <p className={`${isTamil ? "cardtitle_T_1" : "cardtitle_1"}`}>
                {isTamil ? STR_Tam_text15_STA : STR_text15_STA}
              </p>
              <p className={`${isTamil ? "cardcontent_T_1" : "cardcontent_1"}`}>
                {isTamil ? STR_Tam_text16_STA : STR_text16_STA}
              </p>
            </Card>
          </Col>
 
          <Col className="cards_type" span={8}>
            <div className="card-circle">
              <div className="card-wrapper">
                <div className="icon-circle">
                  <img src={Download} className="cards_icon"></img>
                </div>
              </div>
            </div>
            <Card title="" bordered={false} className="customcard-overlap">
              <p className={`${isTamil ? "cardtitle_T_1" : "cardtitle_1"}`}>
                {isTamil ? STR_Tam_text17_STA : STR_text17_STA}
              </p>
              <p className={`${isTamil ? "cardcontent_T_1" : "cardcontent_1"}`}>
                {isTamil ? STR_Tam_text18_STA : STR_text18_STA}
              </p>
            </Card>
          </Col>
 
          <Col className="cards_type" span={8}>
            <div className="card-circle">
              <div className="card-wrapper">
                <div className="icon-circle">
                  <img src={MobileLayout} className="cards_icon"></img>
                </div>
              </div>
            </div>
            <Card title="" bordered={false} className="customcard-overlap">
              <p className={`${isTamil ? "cardtitle_T_1" : "cardtitle_1"}`}>
                {isTamil ? STR_Tam_text19_STA : STR_text19_STA}
              </p>
              <p className={`${isTamil ? "cardcontent_T_1" : "cardcontent_1"}`}>
                {isTamil ? STR_Tam_text20_STA : STR_text20_STA}
              </p>
            </Card>
          </Col>
        </Row>
      </div>
    );
  };
 
  return (
    <div>
      <ShareIntroSection />
      <DownloadSection />
      <FeaturesSection />
      <CardsSection />
      <Footer />
    </div>
  );
};
// Map Redux state to component props
const mapStateToProps = (state) => ({
  isTamil: state.LanguageReducer.isTamil,
});
 
export default connect(mapStateToProps)(SharethisApp);
 